"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVMFeeData = exports.UtxoFeeData = exports.BaseFeeData = void 0;
const transaction_1 = require("./transaction");
class BaseFeeData {
    chain;
    asset;
    amount;
    type;
    assetId;
    spending;
    constructor(chain, amount, type) {
        this.chain = chain;
        this.asset = chain.asset;
        this.amount = amount;
        this.type = type;
        this.assetId = chain.assetId;
        this.spending = new transaction_1.BaseSpending(this.chain, this.amount, this.assetId);
    }
    getAssetValue() {
        return this.asset.getAssetValue(this.amount);
    }
}
exports.BaseFeeData = BaseFeeData;
class UtxoFeeData extends BaseFeeData {
    transaction;
    spending;
    constructor(chain, amount, type, transaction) {
        super(chain, amount, type);
        this.transaction = transaction;
        this.spending = new transaction_1.UtxoSpending(this.chain, this.amount, this.assetId, this.transaction.getUtxos());
    }
    getAssetValue() {
        return this.chain.asset.getAssetValue(this.amount);
    }
}
exports.UtxoFeeData = UtxoFeeData;
class EVMFeeData extends BaseFeeData {
    baseFee;
    gasLimit;
    data;
    constructor(chain, amount, type, baseFee, gasLimit, data) {
        super(chain, amount, type);
        this.baseFee = baseFee;
        this.gasLimit = gasLimit;
        this.data = data;
    }
    setGasLimit(gasLimit) {
        this.amount = this.baseFee * gasLimit;
        this.spending.amount = this.amount;
        this.gasLimit = gasLimit;
    }
}
exports.EVMFeeData = EVMFeeData;
